@if (isExistingEmployee && !userProfileErrorMsg) {
  <p>
    Your UPMC account is not configured properly. Please contact the Help Desk by calling 412-647-HELP or using the Help Desk chat feature.
    The support issue should be sent to the IMS Support group with this information: "My Employee ID in Active Directory is mismatched or
    missing and should be corrected."
  </p>
}
@if (!isExistingEmployee && !userProfileErrorMsg) {
  <p>
    The Vaccine Portal is only accessible for active UPMC Employees. Please check with your supervisor to determine your compliance
    requirements. Access for newly-hired UPMC employees may take up to 2 days to process.
  </p>
}
@if (userProfileErrorMsg) {
  <p>{{ userProfileErrorMsg }}</p>
}
